import axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import * as _ from '@reolink-web/utils';
import { IHttpRequestOpts, IRequestConfig } from './interface';
export class HttpClient {

    public _client: AxiosInstance;

    public _defaults: IRequestConfig;

    public constructor( client: AxiosInstance, defaultsContext: IRequestConfig = {}) {

        this._client = client;

        this._defaults = defaultsContext;

    }

    public get<T = any>( url: string, option?: IRequestConfig ): AxiosPromise<T> {

        return this._client.get<T>( url, this._extend( option ));

    }

    public post<T = any>( url: string, data: Record<string, any>, option?: IRequestConfig ): AxiosPromise<T> {

        return this._client.post<T>( url, data, this._extend( option ));

    }

    public delete( url: string, option?: IRequestConfig ): AxiosPromise {

        return this._client.delete( url, this._extend( option ));

    }

    public put<T = any>( url: string, data: Record<string, any>, option?: IRequestConfig ): AxiosPromise<T> {

        return this._client.put<T>( url, data, this._extend( option ));

    }

    public patch<T = any>( url: string, data: Record<string, any>, option?: IRequestConfig ): AxiosPromise<T> {

        return this._client.patch<T>( url, data, this._extend( option ));

    }

    public all( request: Array<any | Promise<any>> ): Promise<any[]> {

        return axios.all( request );

    }

    public setHeader( key: string, value: string ): void {

        if ( !this._defaults.headers ) {

            this._defaults.headers = {};

        }

        this._defaults.headers[key] = `${value}`;

    }

    /**
     * http request
     */
    public httpRequest( opts: IHttpRequestOpts ): any {

        const method = opts.method;

        let config = {};

        if ( opts.config ) {

            config = opts.config;

        }

        config = this._extend( config );

        switch ( method ) {

            case 'GET':
                return this.get( opts.url, config );
            case 'POST':
                return this.post( opts.url, opts.data, config );
            case 'DELETE':
                return this.delete( opts.url, config );
            case 'PUT':
                return this.put( opts.url, opts.data, config );
            case 'PATCH':
                return this.patch( opts.url, opts.data, config );
            case 'ALL':
                return this.all( opts.request! );

        }

    }

    private _extend( options ): IRequestConfig {

        if ( options ) {

            return _.Object.deepMerge( this._defaults, options );

        }

        return this._defaults;

    }

}
